module.exports = __webpack_public_path__ + "static/img/6.71641e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/eng/6.png
// module id = MtUC
// module chunks = 0